/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

import React, {ReactNode} from 'react';

// TODO resize with scale? colors should be variables
export function Nubbin(): ReactNode {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <g
        fill="var(--spectrum-global-color-blue-600)"
        stroke="var(--spectrum-global-color-blue-600)"
        strokeWidth="2">
        <circle cx="8" cy="8" r="8" stroke="none" />
        <circle cx="8" cy="8" r="7" fill="none" />
      </g>
      <path
        d="M-2106-7380.263v5l2.5-2.551Z"
        transform="translate(2116 7385.763)"
        fill="#fff"
        stroke="#fff"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M-2106-7380.263v5l2.5-2.551Z"
        transform="translate(-2100 -7369.763) rotate(180)"
        fill="#fff"
        stroke="#fff"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}
